import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getListingDetail } from '../dishes/api';
import { getOrderDetail, searchOrders, type OrderSearchParams } from './api';

export const orderKeys = {
  all: ['orders'] as const,
  detail: (id: string) => [...orderKeys.all, 'detail', id] as const,
  search: (params: OrderSearchParams) => [...orderKeys.all, 'search', params] as const,
};

export const dishKeys = {
  all: ['dishes'] as const,
  detail: (id: string) => [...dishKeys.all, 'detail', id] as const,
};

/** Details are shown inline with a retry, so failures are silent. */
export function useOrderDetail(id: string) {
  return useQuery({
    queryKey: orderKeys.detail(id),
    queryFn: ({ signal }) => getOrderDetail(id, signal),
    meta: { silent: true },
  });
}

export function useListingDetail(id: string) {
  return useQuery({
    queryKey: dishKeys.detail(id),
    queryFn: ({ signal }) => getListingDetail(id, signal),
    meta: { silent: true },
  });
}

export function useOrderSearch(params: OrderSearchParams, opts: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: orderKeys.search(params),
    enabled: opts.enabled ?? true,
    queryFn: ({ signal }) => searchOrders(params, signal),
    placeholderData: keepPreviousData,
    meta: { silent: true },
  });
}
